import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { IzIntegrationDataProviderFactory } from '../factory/IzIntegrationDataProviderFactory';
import { IzIntegrationBaseDataProvider } from '../dataProvider/IzIntegrationBaseDataProvider';
import { IzIntegrationWebComponentSchema } from '../types';

export class IzIntegrationRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IzIntegrationDataProviderFactory;
  public dataProvider: IzIntegrationBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IzIntegrationDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<IzIntegrationWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
